export default __webpack_public_path__ + "static/media/deleteEntryButton.84f87bb8.svg";